import { render, staticRenderFns } from "./left-column.vue?vue&type=template&id=453b214b&"
import script from "./left-column.vue?vue&type=script&lang=js&"
export * from "./left-column.vue?vue&type=script&lang=js&"
import style0 from "./left-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports